import { render, staticRenderFns } from "./CouponCreateForm.vue?vue&type=template&id=496cd2f7&"
import script from "./CouponCreateForm.vue?vue&type=script&lang=js&"
export * from "./CouponCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports